var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0 text-center"},[_c('span',{staticClass:"d-block d-md-inline-block mt-25",style:({color: '#b0b3b8'})},[_vm._v(" COPYRIGHT © "+_vm._s(new Date().getFullYear())+" by EAERA LTD. All rights Reserved ")])])}
var staticRenderFns = []

export { render, staticRenderFns }